

















































































































































import Vue from "vue";
import {computed, ref, onBeforeMount} from "@vue/composition-api";
import formatDate from "../../../helpers/formatDate";
import formatScheduleDate from "../../../helpers/formatScheduleDate";

export default Vue.extend({
  name: "CampaignsList",
  setup(props, context: any): any {
    const loading = computed(() => context.root.$store.state.loading);
    const store = computed(() => context.root.$store.state.store);
    const campaignsList = computed(
      () => context.root.$store.state.campaigns.campaignsList.data
    );
    const headers = [
      {
        text: "Campaign Name",
        value: "campaignName",
        sortable: false
      },
      {
        text: "Message",
        value: "message",
        sortable: false
      },
      {
        text: "Status",
        value: "status",
        sortable: false
      },
      {
        text: "Scheduled",
        value: "scheduled",
        sortable: false
      },
      {
        text: "Created",
        value: "created",
        sortable: false
      },
      {
        text: "",
        value: "actions",
        sortable: false
      }
    ];

    const deleteModal = ref(false);
    const cancelModal = ref(false);

    const campaignDelete = ref(null);
    const campaignCancel = ref(null);

    function getCampaignsList() {
      const nextPageToken =
        context.root.$store.state.campaigns.campaignsList.nextPageToken;

      let payload = {};
      if (nextPageToken) {
        payload = {nextPageToken};
      } else {
        payload = {};
      }
      context.root.$store.dispatch("campaigns/getCampaignsList", {
        ...payload
      });
    }

    function pageUpdate() {
      const nextPageToken =
        context.root.$store.state.campaigns.campaignsList.nextPageToken;
      if (nextPageToken) {
        getCampaignsList();
      }
    }

    function statusColor(status) {
      let color = "";
      switch (status) {
        case "CANCELLED":
          color = "warning";
          break;
        case "SENDING":
          color = "info";
          break;
        case "SENT":
          color = "success";
          break;
        case "DRAFT":
          color = "lightgray";
          break;
      }
      return color;
    }

    function handleDelete(campaign) {
      campaignDelete.value = campaign;
      deleteModal.value = true;
    }

    function handleCancel(campaign) {
      campaignCancel.value = campaign;
      cancelModal.value = true;
    }

    function handleConfirmDelete() {
      context.root.$mixpanel.track("Click", {
        Parent: "Campaigns",
        Action: "Delete Campaign"
      });
      context.root.$store
        .dispatch("campaigns/deleteCampaign", campaignDelete.value.name)
        .then(res => {
          campaignDelete.value = null;
          deleteModal.value = false;
          context.root.$store.dispatch("campaigns/resetCampaignList");
          getCampaignsList();
        });
    }

    function handleConfirmCancel() {
      context.root.$mixpanel.track("Click", {
        Parent: "Campaigns",
        Action: "Cancel Campaign"
      });
      context.root.$store
        .dispatch("campaigns/cancelCampaign", campaignCancel.value.name)
        .then(res => {
          campaignCancel.value = null;
          cancelModal.value = false;
          context.root.$store.dispatch("campaigns/resetCampaignList");
          getCampaignsList();
        });
    }

    function handleCancelDelete() {
      campaignDelete.value = null;
      deleteModal.value = false;
    }

    function handleCancelCancel() {
      campaignCancel.value = null;
      cancelModal.value = false;
    }

    onBeforeMount(() => {
      context.root.$mixpanel.track("Page Load", {Page: "Campaigns"});
      context.root.$store.dispatch("campaigns/resetCampaignList");
      getCampaignsList();
    });

    return {
      deleteModal,
      cancelModal,
      campaignDelete,
      campaignCancel,
      headers,
      campaignsList,
      pageUpdate,
      store,
      loading,
      formatDate,
      formatScheduleDate,
      statusColor,
      handleDelete,
      handleCancel,
      handleConfirmDelete,
      handleConfirmCancel,
      handleCancelDelete,
      handleCancelCancel
    };
  }
});
